import { MutateOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";

export type Personel = {
  id: string;
  name: string;
  description: string;
  date: string;
  created_at: string;
  person_who_assign: {
    id: string;
    email: string;
    fullname: string;
    username: string;
    date_of_start: string;
    salary_net: number;
    salary_gross: number;
    phone_number: string;
  };
  person_who_complete: {
    id: string;
    email: string;
    fullname: string;
    username: string;
    date_of_start: string;
    salary_net: number;
    salary_gross: number;
    phone_number: string;
  };
};

export interface TodoListResponse extends Array<Personel> {}

export interface TodoModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Personel;
  mutate: (
    variables: any,
    options?:
      | MutateOptions<TodoListResponse, AxiosError<any>, any, unknown>
      | undefined
  ) => void;
}

export interface TodoDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Personel;
}

export interface TodoAddRequest {
  id?: string;
  name?: string;
  description: string;
  date: Date;
  person_who_assign_id?: string | null | number;
  assingPersonName?: string;
}

export interface TodoAddResponse {
  name: string;
  description: string;
  date: Date;
  person_who_assign_id: Personel;
  status: number;
}

export interface TodoUpdateRequest {
  id?: string;
  name?: string;
  description?: string;
  date?: string;
  person_who_assign?: any;
  person_who_complete?: string | null | number;
  assingPersonName?: string;
}

export interface TodoUpdateResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface TodoDeleteRequest {
  id: string;
}

export interface TodoDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export const todoAddSchema = yup.object().shape({
  name: yup.string().required("İş adı boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  date: yup.date().required("İş tarihi boş bırakılamaz"),
});

export const todoUpdateSchema = yup.object().shape({
  name: yup.string().required("İş adı boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  date: yup.date().required("İş tarihi boş bırakılamaz"),
});

export const assignType = {
  ASSING_OWN: "ME",
  ASSING_ALL: "ALL",
  ASSING_PERSON: "PERSON",
};

export const assignPersonOptions = [
  { key: "Herkese", value: assignType.ASSING_ALL },
  { key: "Kendime", value: assignType.ASSING_OWN },
  { key: "Çalışan", value: assignType.ASSING_PERSON },
];

export const assignFormatter = (selectedId?: string, userId?: number) => {
  if (selectedId == userId) return assignType.ASSING_OWN;
  if (selectedId != userId && selectedId !== undefined)
    return assignType.ASSING_PERSON;

  return assignType.ASSING_ALL;
};
